(function () {
    'use strict';

    angular
        .module('adm')
        .controller('AdmProcessEditController', AdmProcessEditController);

    AdmProcessEditController.$inject = ['$uibModalInstance', 'AdmService', 'process', 'admProcessList'];

    function AdmProcessEditController($uibModalInstance, AdmService, process, admProcessList) {
        var vm = this;

        vm.ok               = ok;
        vm.cancel           = cancel;
        vm.update           = update;
        vm.process          = {};
        vm.getDepartments   = getDepartments;
        vm.priorities       = [{ id : 'LOW', name : 'Low'}, { id : 'MEDIUM', name : 'Medium'}, { id : 'HIGH', name : 'High'}];
        vm.prioritySelected = '';
        vm.departmentSelected = '';
        vm.positionSelected   = '';
        vm.getJobDescriptionsForSelect = getJobDescriptionsForSelect;
        vm.addStage             = addStage;
        vm.removeStage          = removeStage;
        vm.addStageItem         = addStageItem;
        vm.removeStageItem      = removeStageItem;
        vm.getResponsible       = getResponsible;
        vm.getResponsiblePositions = getResponsiblePositions;
        vm.getStageResponsible  = getStageResponsible;
        vm.getStageResponsiblePositions  = getStageResponsiblePositions;


        angular.copy(process, vm.process);

        activate();

        function activate() {

            vm.getDepartments();
            vm.getJobDescriptionsForSelect();
            vm.departmentSelected = vm.process.department.id;

            vm.jobDescriptionSelected = {id : vm.process.job_description.id, name : vm.process.job_description.name};
            /* Responsible */
            vm.getResponsible();
            vm.responsibleSelected = vm.process.adm_user_id;
            /* Positions */
            vm.getResponsiblePositions();
            vm.positionSelected = vm.process.adm_job_description_id;
            /* Priority */
            vm.prioritySelected = vm.process.priority;

            // angular.forEach(vm.priorities, function(priority) {
            //     if(priority.id === vm.process.priority){
            //         vm.prioritySelected = priority;
            //     }
            // });

            // angular.forEach(vm.process, function(adm_process) {
            //     angular.forEach(adm_process.stages, function(stage) {
            //         console.log(stage);
            //         stage.responsiblePositions = vm.getStageResponsiblePositions(stage);
            //     });
            // });

            vm.getStageItemResponsible = getStageItemResponsible;
            vm.getStageItemResponsiblePositions = getStageItemResponsiblePositions;

        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function update() {

            vm.query = {};
            vm.query['id']          = vm.process.id;
            vm.query['department']  = vm.departmentSelected;
            vm.query['responsible'] = vm.responsibleSelected;
            vm.query['position']    = vm.positionSelected;
            vm.query['name']        = vm.process.name;
            vm.query['priority']    = vm.prioritySelected;
            vm.query['where']       = vm.process.where;
            vm.query['description'] = vm.process.description;
            vm.query['stages']      = vm.process.stages;
            /*
            vm.query = {};
            vm.query['id']                      = vm.process.id;
            vm.query['name']                    = vm.process.name;
            vm.query['description']             = vm.process.description;
            vm.query['priority']                = vm.prioritySelected.id;
            vm.query['adm_job_description_id']  = vm.jobDescriptionSelected;
            vm.query['where']                   = vm.process.where;
            vm.query['adm_department_id']       = vm.departmentSelected;
            vm.query['stages']                  = vm.process.stages; */
            AdmService.updateProcess(vm.query).then(function(response){
                alertify.notify('Process is successfully updated', 'success', 3);
                // department.name = vm.department.name;
                // department.description = vm.department.description;
                admProcessList.getByFilter();
                vm.cancel();
            }).catch(function(err) {
                alertify.notify('An error occurred on update', 'error', 3);
            });
        }

        function getDepartments()
        {
            vm.query = {};
            AdmService.getDepartmentsForSelect(vm.query).then(function(response){
                vm.departments = response.data;
            });
        }

        function getJobDescriptionsForSelect()
        {
            AdmService.getJobDescriptionsForSelect().then(function(response){
                vm.jobDescriptions  = response.data;
            }).catch(function(err) {

            });
        }

        function addStage()
        {
            vm.stage = {name : '', department_id : '', adm_user_id : '', items : [{ name : ''}], department : {responsible : []}, job_descriptions : []}
            vm.addStageItem(vm.stage);
            vm.process.stages.push({
                    name : '',
                    department_id : '',
                    adm_user_id : '',
                    items : [{
                        name : '',
                        adm_department_id : '',
                        adm_user_id : '',
                        department : {responsible : []}, job_descriptions : []
                    }],
                    department : {responsible : []},
                    job_descriptions : []
                });
        }

        function removeStage(field)
        {
            vm.process.stages.splice(vm.process.stages.indexOf(field), 1);
        }

        function addStageItem(stage)
        {
            stage.items.push({name : '', adm_department_id : '', adm_user_id : '', department : {responsible : []}, job_descriptions : []});
        }

        function removeStageItem(stage, item)
        {
            stage.items.splice(stage.items.indexOf(item), 1);
        }

        function getResponsible()
        {
            vm.query = {};
            vm.query['department'] = vm.departmentSelected;
            AdmService.getResponsible(vm.query).then(function(response){
                vm.responsible = response.data;
            });
        }

        function getResponsiblePositions()
        {
            vm.query = {};
            vm.query['user'] = vm.responsibleSelected;
            AdmService.getResponsiblePositions(vm.query).then(function(response){
                vm.responsiblePositions = response.data;
            });
        }

        function getStageResponsible(stage)
        {
            vm.query = {};
            vm.query['department'] = stage.department_id;
            AdmService.getResponsible(vm.query).then(function(response){
                stage.department.responsible = response.data;
            });
        }

        function getStageResponsiblePositions(stage)
        {
            vm.query = {};
            vm.query['user'] = stage.adm_user_id;
            AdmService.getResponsiblePositions(vm.query).then(function(response){
                stage.job_descriptions = response.data;
                if(stage.job_descriptions.length === 1){
                    stage.adm_job_description_id = stage.job_descriptions[0].id;
                }
            });
        }

        function getStageItemResponsible(item)
        {
            vm.query = {};
            vm.query['department'] = item.adm_department_id;
            AdmService.getResponsible(vm.query).then(function(response){
                item.department.responsible = response.data;
            });
        }

        function getStageItemResponsiblePositions(stage)
        {
            vm.query = {};
            vm.query['user'] = stage.adm_user_id;
            AdmService.getResponsiblePositions(vm.query).then(function(response){
                stage.job_descriptions = response.data;
                if(stage.job_descriptions.length === 1){
                    stage.adm_job_description_id = stage.job_descriptions[0].id;
                }
            });
        }
    }

})();